<div
  class="relative mt-6 flex shrink-0 flex-col items-center justify-center gap-6 rounded-2xl border border-solid border-blue-200 bg-blue-50 pb-4 pl-4 pr-4 pt-4 md:flex-row md:gap-10"
>
  <div class="-sm:text-center relative text-blue-900">Save time and autofill your current location</div>
  <button cslButton="secondary" type="button" (click)="getCoordinates()" data-testid="autofill-button">Autofill</button>
  <!-- TEST BUTTONS
  <button cslButton="secondary" type="button" (click)="getTestCoordinates()">T</button>
  <button cslButton="secondary" type="button" (click)="getTrashAndRecycleCoordinates()">TR</button>
  -->

  @if (inProgress) {
    <div class="absolute flex h-full w-full items-center justify-center rounded-2xl bg-blue-100 opacity-80">
      <i class="g-filter-blue-800 block h-12 w-12 animate-spin bg-[url(../assets/icons/loader-icon.svg)]"></i>
    </div>
  }
</div>

@if (hasError) {
  <div
    class="relative mt-2 flex shrink-0 items-start justify-start gap-2 self-stretch pl-1 pr-1"
    data-testid="autofill-error-message"
  >
    <!--    TODO: Check if the color is applied to the icon-->
    <i class="g-filter-red-600 block h-5 w-5 bg-[url(../assets/icons/warning-icon.svg)]"></i>
    <div class="text-crimson-700 relative flex-1 text-left text-sm font-normal">
      We couldn’t find your location! Please allow access to your location in browser settings.
    </div>
  </div>
}
